/** Vercel Blob storage base URL */
const BLOB_BASE = 'https://glnnsqhevc18r8ka.public.blob.vercel-storage.com';

/**
 * Construct Vercel Blob storage URL
 * @param path - full path after base (e.g., 'images/profiles/photo.jpg', 'videos/clip.mp4')
 */
export function getBlobUrl(path: string): string {
  return `${BLOB_BASE}/${path}`;
}
